import React, { Component } from "react";
import DropdownComponent from "../../components/dropdown";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from '@mui/icons-material/Edit';
import { TriggersState } from "../../store/triggers/types";
import { withStyles, styled } from "@mui/material/styles";
import { containsObject, removeDuplicateObjects } from "../../lib/common";
//import { deleteDestination } from '../../store/destinations/actions';
import "./triggers.css";
import DestinationTestResult from "./DestinationTestResult";
import {
  Alert,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Input,
  ListItemIcon,
  ListItemText,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";

import { QueryBuilderDnD } from '@react-querybuilder/dnd';
import * as ReactDnD from 'react-dnd';
import * as ReactDndHtml5Backend from 'react-dnd-html5-backend';
import { RuleGroupType, formatQuery } from 'react-querybuilder';
import { QueryBuilder, defaultOperators } from 'react-querybuilder';
import 'react-querybuilder/dist/query-builder.css';

import './queryBuilderOverride.css';
import { DestinationsState } from "../../store/destinations/types";
import { decodeVarbinary, urlLengthError, SAVE_FAILED_MESSAGE } from "../../lib/destinationUtils";

const styles = (theme) => ({
  checked: {
    color: "#6366F1",
    "font-weight": "600",
  },
  colorSecondary: {
    color: "#6366F1 !important",
  },
});

interface TriggerCardInterfaceProps {
  triggers: TriggersState;
  emptyTrigger: Function;
  deleteDestination: any;
  deleteTrigger: any;
  testDestination: any;
  updateTriggerField: Function;
  classes: any;
  trigger: any;
  destinations: any;
  loadTriggerById2: any;
  saveTrigger: any;
  history?: any;
  emptyDestination: any
  updateDestinationField: any
  edittedDestination: any
  saveDestination: any
  clientId: any
  destination: DestinationsState;
  loadTriggers: Function;
  isAnyTriggerEditing: boolean;
  setIsAnyTriggerEditing: Function;
}

let operators: Array<any> = [];
for (let i = 0; i < defaultOperators.length; i++) {
  if (defaultOperators[i].name !== 'in' && defaultOperators[i].name !== 'notIn' && defaultOperators[i].name !== 'notIn' && defaultOperators[i].name !== 'between' && defaultOperators[i].name !== 'notBetween') {
    operators.push(defaultOperators[i]);
  }
}

const parameters = [
  { name: "custom1", label: "Custom1" },
  { name: "custom2", label: "Custom2" },
  { name: "custom3", label: "Custom3" },
  { name: "custom4", label: "Custom4" },
  { name: "custom5", label: "Custom5" },
  { name: "custom6", label: "Custom6" },
  { name: "custom7", label: "Custom7" },
  { name: "custom8", label: "Custom8" },
  { name: "custom9", label: "Custom9" }
];

const options = {
  email: 'Email Address',
  hashEmail: 'Hash Email',
  timestamp: 'Timestamp of Visit',
  sourceId: 'Source ID',
  clckId: 'Click ID',
  custom1: 'Custom + 1-10',
};

const fields = [
  {
    name: "email",
    label: "Email",
    operators: operators
  },
  {
    name: "url",
    label: "URL",
    operators: operators
  },
  /*{
    name: "urlParam",
    label: "URL Parameter",
    operators: operators
  },*/
  /*{
    name: "landingDomain",
    label: "Domain",
    operators: operators
  },*/
  {
    name: "country",
    label: "Country",
    operators: operators
  },
  {
    name: "state",
    label: "State",
    operators: operators
  },
  {
    name: "device",
    label: "Device",
    operators: operators
  },
  {
    name: "zid",
    label: "zid",
    operators: operators
  },
  {
    name: "pid",
    label: "pid",
    operators: operators
  },
  {
    name: "cid",
    label: "cid",
    operators: operators
  },
  {
    label: "Custom 1",
    name: "custom1",
    operators: operators
  },
  {
    label: "Custom 2",
    name: "custom2",
    operators: operators
  },
  {
    label: "Custom 3",
    name: "custom3",
    operators: operators
  },
  {
    label: "Custom 4",
    name: "custom4",
    operators: operators
  },
  {
    label: "Custom 5",
    name: "custom5",
    operators: operators
  },
  {
    label: "Custom 6",
    name: "custom6",
    operators: operators
  },
  {
    label: "Custom 7",
    name: "custom7",
    operators: operators
  },
  {
    label: "Custom 8",
    name: "custom8",
    operators: operators
  },
  {
    label: "Custom 9",
    name: "custom9",
    operators: operators
  },
  {
    name: "page_count",
    label: "Page Count",
    operators: operators.filter((op) => ['>=', '>', '<', '<=', '='].includes(op.name)),
    inputType: 'number'
  }

  /*,
  {
    name: "timeOnPage",
    label: "Time on Page (seconds)",
    operators: defaultOperators.filter((op) => op.name === '>' || op.name === '<'),
    inputType: 'number'
  }*/
];

const condition_options = [
  { name: "Contains", value: "contain" },
  { name: "Does not Contain", value: "notContain" },
  { name: "Exactly Matches", value: "exactMatch" },
  { name: "Does not Exactly Match", value: "notExactMatch" },
  { name: "Starts With", value: "startWith" },
  { name: "Does not Start With", value: "notStartWith" },
  { name: "Ends With", value: "endWith" },
  { name: "Does not End With", value: "notEndWith" },
  { name: "Greater Than", value: "greaterThan" },
  { name: "Less Than", value: "lessThan" },
  { name: "After", value: "after" },
  { name: "Before", value: "before" },
  { name: "Equals", value: "equals" },
  { name: "Exists", value: "exists" },
  { name: "Does not Exist", value: "notExists" },
];

const type_options = [{ name: "webhook", value: "webhook" }];

// Product-event config (Klaviyo key, list ids, product macros, active/paused)
// lives on the Product Events screen now — deliberately not configurable here.
// decodeVarbinary is imported from the shared lib for the same reason.

const methods = [
  { name: "GET", value: "GET" },
  { name: "POST", value: "POST" },
];

type MyState = {
  selectedCondition: string;
  isEdit: boolean;
  destinations: any;
  testingTrigger: boolean;
  testResults: any;
  selectedDestinations: any;
  openAddNewOptionsModal: boolean;
  destSaving: boolean;
  destSaveError: string | null;
  triggerName: string;
  startDate: string;
  endDate: string;
  optionObject: any;
  filterOptions: any;
  dynamicData: any;
  triggerFireCount: number;
};

class TriggerCard extends Component<TriggerCardInterfaceProps, MyState> {
  state: MyState = {
    // optional second annotation for better type inference
    selectedCondition: "text",
    isEdit: false,
    destinations: this.props.destinations,
    testingTrigger: false,
    testResults: {},
    selectedDestinations: [],
    openAddNewOptionsModal: false,
    destSaving: false,
    destSaveError: null,
    triggerName: this.props.trigger.name,
    startDate: this.props.trigger.startDate.split('T')[0],
    endDate: this.props.trigger.endDate.split('T')[0],
    optionObject: {
      name: "",
      type: "",
      url: "",
      headers: "",
      method: "",
      emailRename: "",
    },
    filterOptions: JSON.parse(this.props.trigger.filterOptions),
    dynamicData: JSON.parse(this.props.trigger.dynamicData),
    triggerFireCount: this.props.trigger.fireCount,
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.editTrigger = this.editTrigger.bind(this);
    this.handleChangeDestination = this.handleChangeDestination.bind(this);
    this.handleChangeAddOption = this.handleChangeAddOption.bind(this);
    this.getEdittedTriggerData = this.getEdittedTriggerData.bind(this);
    this.handleChangeFilters = this.handleChangeFilters.bind(this);
    this.inputForFilter = this.inputForFilter.bind(this);
    this.saveTriggerData = this.saveTriggerData.bind(this);
    this.addExtraFilter = this.addExtraFilter.bind(this)
    this.deleteTrigger = this.deleteTrigger.bind(this);
    this.testDestination = this.testDestination.bind(this);
    this.copy = this.copy.bind(this); 
    this.editDestination = this.editDestination.bind(this);
  }

  public componentDidMount(): void {
    let modifiedSelectedDestinations = [];
    modifiedSelectedDestinations = this.props.destinations &&
      this.props.destinations.length &&
      this.props.destinations.filter((item) => {
        if (this.props.trigger && this.props.trigger.destinationIds &&
          this.props.trigger.destinationIds.split(",").includes(item.id.toString())
        ) {
          return item;
        }
      });
    this.setState({ selectedDestinations: modifiedSelectedDestinations });
    this.props.emptyDestination();
    this.props.updateTriggerField("clientId", this.props.clientId)
  }

  public componentDidUpdate(
    prevProps: Readonly<TriggerCardInterfaceProps>,
    prevState: Readonly<MyState>,
    snapshot?: any
  ): void {
    let modifiedSelectedDestinations = [];
    if (this.props.destinations !== prevProps.destinations && !this.state.isEdit) {
      this.setState({ destinations: this.props.destinations });
      modifiedSelectedDestinations = this.props.destinations &&
        this.props.destinations.length &&
        this.props.destinations.filter((item) => {
          if (this.props.trigger && this.props.trigger.destinationIds &&
            this.props.trigger.destinationIds.split(",")
              .includes(item.id.toString())
          ) {
            return item;
          }
        });
      this.setState({ selectedDestinations: modifiedSelectedDestinations });
    }

    let filterOptions = this.state.filterOptions;
    if (this.state.isEdit != prevState.isEdit) {
      filterOptions =
        this.props.triggers.editedTrigger.filterOptions &&
        this.props.triggers.editedTrigger.filterOptions != undefined &&
        JSON.parse(this.props.triggers.editedTrigger.filterOptions);
      this.setState({
        filterOptions: filterOptions || {
          "filters": [
            {
              "field": "",
              "operator": "",
              "value": ""
            },
          ]
        }
      });
    }
  }

  public copy(e, key) {
    e.preventDefault();
    const tag = '{{' + key + '}}';
    navigator.clipboard.writeText('{{' + key + '}}');

    const el: any = document.activeElement;
    if (el && (el.nodeName === 'INPUT' || el.nodeName === 'TEXTAREA')) {
      const newCursorPos = el.selectionStart + tag.length;
      el.value =
        el.value.substring(0, el.selectionStart) +
        tag +
        el.value.substring(el.selectionEnd);
      el.setSelectionRange(newCursorPos, newCursorPos);

      this.handleChangeAddOption('url', el.value);
    } else {
      // nothing focused (fresh modal) — append the macro to the URL field so
      // the chip always visibly does something
      const current = (this.state.optionObject && this.state.optionObject.url) ||
        (this.props.edittedDestination && this.props.edittedDestination.url) || '';
      this.handleChangeAddOption('url', current + tag);
    }
  }
  
  private inputForFilter(condition: string) {
    let type = 'text';
    if (condition == "Greater Than" || condition == "Less Than") {
      type = 'number'
    } else if (
      condition == "After" ||
      condition == "Before" ||
      condition == "Equals"
    ) {
      type = "date";;
    } else {
      type = "text";;
    }
    return type
  }

  private setQuery(query) {
    console.log(query);
    console.log(formatQuery(query, 'json'));
    this.handleChange("filterOptions", formatQuery(query, 'json'));
    this.setState({ filterOptions: query });
  }

  private setDynamicData(field, value) {
    console.log(field);
    console.log(value);
    var dynamic = this.state.dynamicData;
    dynamic[field] = value;
    this.handleChange("dynamicData", JSON.stringify(dynamic));
    this.setState({ dynamicData: dynamic });
  }

  private handleChange(field: string, value: any, type?: any): void {
    let modifiedValue = value;
    if (field == "condition") {
      if (value.value == "Greater Than" || value.value == "Less Than") {
        this.setState({ selectedCondition: "number" });
      } else if (
        value.value == "After" ||
        value.value == "Before" ||
        value.value == "Equals"
      ) {
        this.setState({ selectedCondition: "date" });
      } else {
        this.setState({ selectedCondition: "text" });
      }
      return;
    } else if (type == "dropdown") {
      modifiedValue = value.value;
    }

    if (field == "name") {
      this.setState({ triggerName: modifiedValue });
    }
    this.props.updateTriggerField(field, modifiedValue);
  }

  private noEndChange(e): void {
    if (this.props.triggers.editedTrigger.endDate.split('T')[0] != '2200-01-01') {
      this.setState({ endDate: '2200-01-01' });
      this.handleChange('endDate', '2200-01-01');
    } else {
      const date = new Date();
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 30);
      this.setState({ endDate: endDate.toISOString().split('T')[0] });
      this.handleChange('endDate', endDate.toISOString().split('T')[0]);
    }
  }

  private handleChangeFilters(name: string, value: any, index: number) {
    let filters: any = this.state.filterOptions && this.state.filterOptions.filters

    if (name == 'filter_join') {
      filters[index] = value.value || value;
    } else {
      filters[index][name] = value.value || value;
    }
    this.handleChange("filterOptions", JSON.stringify({ filters: filters }))
  }

  public editTrigger = (event: boolean) => {

  if (event) {
    if (this.props.isAnyTriggerEditing && !this.state.isEdit) {
      alert("Please finish editing the current trigger before editing another one.");
      return;
    }
    this.props.setIsAnyTriggerEditing(true);
  } else {
    this.props.setIsAnyTriggerEditing(false);
  }
  this.setState({ isEdit: event });
};

  public testDestination() {
    this.setState({ testingTrigger: true });
    this.props.testDestination(this.props.edittedDestination);
  }

  public handleChangeDestination = (event, type) => {
    if (event.target.value.includes("NEW")) {
      this.setState({ openAddNewOptionsModal: true, destSaving: false, destSaveError: null });
      this.handleChangeAddOption("clientId", this.props.clientId)
      this.handleChangeAddOption("triggerId", this.props.trigger.id)
      // Blank the credential-bearing fields for a fresh row — redux keeps the
      // previously opened destination's values otherwise (real-key leak risk).
      this.handleChangeAddOption("apiKey", "")
      this.handleChangeAddOption("customProperties", "")
    } else {
      // A "product view" destination is consumed by srecProductViewPoller, NOT by
      // triggers. Never attach one to a trigger: it would receive recognition-fire
      // payloads and spray junk into the client's Klaviyo. It stays visible/editable
      // in the list, just not attachable.
      let selectedDestinations = removeDuplicateObjects(event.target.value, "id")
        .filter((d: any) => d && d.type !== 'product_view');
      this.setState({
        selectedDestinations: selectedDestinations,
      });
      this.props.updateTriggerField("destinationIds", selectedDestinations && selectedDestinations.length ? selectedDestinations.map((item: any) => item.id).join(',') : '');
    }
  };

  public editDestination(id, destination) {
    this.setState({ openAddNewOptionsModal: true, destSaving: false, destSaveError: null });
    let optionObject = { ...destination };
    this.setState({ optionObject: optionObject });
    this.props.updateDestinationField('clientId', destination.clientId);
    this.props.updateDestinationField('id', id);
    this.props.updateDestinationField('name', destination.name);
    this.props.updateDestinationField('type', destination.type);
    this.props.updateDestinationField('method', destination.method);
    this.props.updateDestinationField('url', destination.url);
    this.props.updateDestinationField('emailRename', destination.emailRename);
    this.props.updateDestinationField('body', destination.body);
    this.props.updateDestinationField('headers', destination.headers);
    this.props.updateDestinationField('apiKey', decodeVarbinary(destination.apiKey));
    this.props.updateDestinationField('customProperties', decodeVarbinary(destination.customProperties));

  }

  public handleChangeAddOption = (name, value) => {
    let optionObject = { ...this.state.optionObject };
    optionObject[name] = value;
    this.setState({ optionObject: optionObject });
    console.log('updateDestinationField');
    this.props.updateDestinationField(name, value);
  };

  public saveOption = (e?) => {
    if (e && e.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (this.state.destSaving) return;
    let dest = this.props.edittedDestination;
    if (dest.type !== 'product_view') {
      // No UI sets apiKey for non-product_view types — anything present is
      // stale redux from a previously opened Klaviyo-direct row. Without this
      // strip, a client's real key would get copied onto ordinary webhook
      // rows on save (the '[object Object]' junk on old rows came from this
      // exact leak path, pre-decode).
      dest = { ...dest, apiKey: '' };
      this.props.updateDestinationField('apiKey', '');
    }
    // The database rejects URLs over the column size; say so instead of failing.
    const tooLong = urlLengthError(dest.url);
    if (tooLong) {
      this.setState({ destSaveError: tooLong });
      return;
    }
    // Close only once the save is confirmed; on failure keep the modal open with
    // the typed values (a failed save used to close the modal and lose them).
    this.setState({ destSaving: true, destSaveError: null });
    Promise.resolve(this.props.saveDestination(dest, this.props.history))
      .then(() => this.setState({ destSaving: false, openAddNewOptionsModal: false }))
      .catch(() => this.setState({ destSaving: false, destSaveError: SAVE_FAILED_MESSAGE }));
  };

  public getEdittedTriggerData = (triggerData) => {
    this.props.loadTriggerById2(triggerData);
  };

  public deleteDestination() {
    this.props.deleteDestination(this.props.edittedDestination.id);
    this.setState({ openAddNewOptionsModal: false });
  }

  public deleteTrigger() {
    this.props.deleteTrigger(this.props.triggers.editedTrigger.id);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  public closeTest() {
    this.setState({ testingTrigger: false });
  }

    public saveTriggerData() {
    this.props.saveTrigger(this.props.triggers.editedTrigger, this.props.history);
    this.editTrigger(false); // This already sets isAnyTriggerEditing to false
    console.log('reloading');
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  private addExtraFilter() {
    let filters: any = this.state.filterOptions && [...this.state.filterOptions.filters]

    filters.push(...['AND', {
      "field": "",
      "operator": "",
      "value": ""
      ,
    }]);
    this.setState({ filterOptions: { filters: filters } })
  }

  public render(): JSX.Element {
    const state = this.state;
    const props = this.props;
    const { classes } = this.props;
    console.log(this);

    console.log("edited destination", props.edittedDestination)

    return (
      <>
        {state.openAddNewOptionsModal ? (
          <Dialog
            fullWidth
            aria-labelledby="customized-dialog-title"
            open={state.openAddNewOptionsModal}
            id="customize-dialog-box"
          >
            <div className="customized-dialog-header">
              <DialogTitle id="customized-dialog-title">
                {this.props.edittedDestination.id ? "Edit Option" : "Add New Option"}
              </DialogTitle>
              <div>
                {this.props.edittedDestination.id ?
                  <button id="test-btn" onClick={() => this.testDestination()}>Test</button>
                  : <></>}
                {this.props.edittedDestination.id ?
                  <button onClick={() => this.deleteDestination()}>Delete</button>
                  : <></>}
              </div>
            </div>
            <DialogContent dividers>
              {state.destSaveError ? (
                <Alert severity="error" className="mb-4">{state.destSaveError}</Alert>
              ) : null}
              {state.testingTrigger ? (
                <Dialog
                  fullWidth
                  aria-labelledby="customized-dialog-title"
                  className="customized-dialog-box"
                  open={state.testingTrigger}
                >
                  <DestinationTestResult result={this.props.destination.testResults} />
                  <section className="customized-dialog-box__button"><button onClick={() => this.closeTest()}>Done</button></section>
                </Dialog>) : <></>}
              <form
                //className={classes.root}
                noValidate
                autoComplete="off"
                onSubmit={this.saveOption}
              >
                <div className="flexBox">
                  <div id="w50" className="mb-4">
                    <label className="field_label">Name</label>
                    <input
                      name="name"
                      required
                      type="text"
                      value={props.edittedDestination.name}
                      onChange={(event) =>
                        this.handleChangeAddOption("name", event.target.value)
                      }
                    />
                  </div>
                  <div id="w50" className="mb-4">
                    <label className="field_label">Type</label>
                    <div className="select_multi">
                      <Select
                        name="type"
                        //value={state.selectedDestinations}
                        value={(props.edittedDestination.type) || []}
                        onChange={(event) =>
                          this.handleChangeAddOption("type", event.target.value)
                        }
                        variant="outlined"
                      >
                        {type_options.map((option) => (
                          <MenuItem key={option.name} value={option.value}>
                            <ListItemText primary={option.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                  <div id="w100" className="mb-4">
                    <label className="field_label">URL</label>
                    <input
                      name="url"
                      required
                      type="text"
                      // value={this.props.clients.editedClient.client_name}
                      //value="305-000-0000"
                      value={props.edittedDestination.url}
                      onChange={(event) =>
                        this.handleChangeAddOption("url", event.target.value)
                      }
                      disabled={!state.isEdit}
                    />
                    <div className="options_buttons_area">
                      {Object.entries(options).map(([k, label]) => (
                        <span key={k} className="options_button" title={'{{' + k + '}}'} onMouseDown={e => this.copy(e, k)}>
                          {label}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div id="w50" className="mb-4">
                    <label className="field_label">Headers</label>
                    <input
                      name="headers"
                      required
                      type="text"
                      value={props.edittedDestination.headers}
                      onChange={(event) =>
                        this.handleChangeAddOption(
                          "headers",
                          event.target.value
                        )
                      }
                      disabled={!state.isEdit}
                    />
                  </div>
                  <div id="w50" className="mb-4">
                    <label className="field_label">Method</label>
                    <div className="select_multi">
                      <Select
                        name="method"
                        value={props.edittedDestination.method || []}
                        onChange={(event) =>
                          this.handleChangeAddOption(
                            "method",
                            event.target.value
                          )
                        }
                        variant="outlined"
                      >
                        {methods.map((option) => (
                          <MenuItem key={option.name} value={option.value}>
                            <ListItemText primary={option.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                  <div id="w50" className="mb-4">
                    <label className="field_label">Body</label>
                    <input
                      name="body"
                      required
                      type="text"
                      value={props.edittedDestination.body}
                      onChange={(event) =>
                        this.handleChangeAddOption("body", event.target.value)
                      }
                    />
                  </div>
                  <div id="w50" className="mb-4">
                    <label className="field_label">Custom Properties</label>
                    <input
                      name="customProperties"
                      required
                      type="text"
                      value={props.edittedDestination.customProperties}
                      onChange={(event) =>
                        this.handleChangeAddOption("customProperties", event.target.value)
                      }
                    />
                  </div>
                </div>
              </form>
            </DialogContent>
            <DialogActions>
              <button
                className="button secondary mr-3"
                onClick={() => this.setState({ openAddNewOptionsModal: false, destSaveError: null })}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="button accent"
                disabled={state.destSaving}
                onClick={(event) => this.saveOption(event)}
              >
                {state.destSaving ? "Saving..." : "Save Changes"}
              </button>
            </DialogActions>
          </Dialog>
        ) : null}
        <div className={`trigger_card ${state.isEdit ? 'editing' : ''}`}>
          <div className="d-flex trigger_card__heading mb-4">
            {state.isEdit ? (
              <div id="w33" className="d-flex">
                <label className="field_label mr-4 mb-0">Name</label>
                <input
                  required
                  type="text"
                  value={props.triggers.editedTrigger.name}
                  //value="305-000-0000"
                  onChange={(event) =>
                    this.handleChange("name", event.target.value)
                  }
                  disabled={!state.isEdit}
                />
              </div>
            ) : (
              <div className="d-flex" style={{ alignItems: "baseline" }}>
                    <h3 style={{ 
                      marginBottom: 0, 
                      marginRight: "10px"
                    }}>
                      {state.triggerName || "Trigger Name Example"}
                    </h3>
                    {state.triggerFireCount > 0 && (
                      <span style={{ 
                        color: "rgb(211, 47, 47)", 
                        fontWeight: "bold",
                        verticalAlign: "middle",
                        fontSize: "1rem"
                      }}>
                        Trigger Fires: {state.triggerFireCount}
                      </span>
                    )}
                  </div>
                  )}
                  {state.isEdit ? (
                    <div id="w33" className="d-flex">
                      <label className="field_label mr-4 mb-0">Start Date</label>
                      <input
                        required
                        type="date"
                        value={props.triggers.editedTrigger.startDate.split('T')[0]}
                        //value="305-000-0000"
                        onChange={(event) =>
                          this.handleChange("startDate", event.target.value)
                        }
                        disabled={!state.isEdit}
                      />
                    </div>
            ) : (
              <div id="w33" className="d-flex">
                <label className="field_label mr-4 mb-0">Start Date</label>
                <input
                  required
                  type="date"
                  value={state.startDate.split('T')[0]}
                  //value="305-000-0000"
                  onChange={(event) =>
                    this.handleChange("startDate", event.target.value)
                  }
                  disabled={!state.isEdit}
                />
              </div>
            )}

            {state.isEdit ? (
              <div className="d-flex">
                <label className="field_label mr-4 mb-0">No End?</label>
                <input
                  required
                  type="checkbox"
                  checked={props.triggers.editedTrigger.endDate.split('T')[0] == '2200-01-01'}
                  //value="305-000-0000"
                  onChange={(e) =>
                    this.noEndChange("noEnd")
                  }
                  disabled={!state.isEdit}
                />
              </div>
            ) : (
              <div className="d-flex">
                <label className="field_label mr-4 mb-0">No End?</label>
                <input
                  required
                  type="checkbox"
                  checked={state.endDate.split('T')[0] == '2200-01-01'}
                  //value="305-000-0000"
                  onChange={(e) =>
                    this.noEndChange("noEnd")
                  }
                  disabled={!state.isEdit}
                />
              </div>
            )}

            {state.isEdit && state.endDate.split('T')[0] != '2200-01-01' ? (
              <div className="d-flex">
                <label className="field_label mr-4 mb-0">End Date</label>
                <input
                  required
                  type="date"
                  value={props.triggers.editedTrigger.endDate.split('T')[0]}
                  //value="305-000-0000"
                  onChange={(event) =>
                    this.handleChange("endDate", event.target.value)
                  }
                  disabled={!state.isEdit}
                />
              </div>
            ) : state.endDate.split('T')[0] != '2200-01-01' ? (
              <div className="d-flex">
                <label className="field_label mr-4 mb-0">End Date</label>
                <input
                  required
                  type="date"
                  value={state.endDate.split('T')[0]}
                  //value="305-000-0000"
                  onChange={(event) =>
                    this.handleChange("endDate", event.target.value)
                        }
                        disabled={!state.isEdit}
                      />
                    </div>
                  ) : ''}
      
                  {state.isEdit ? (
                    <div>
                      <button
                        className="delete-button"
                        onClick={() => this.deleteTrigger()}
                      >
                        Delete
                      </button>
                      <button
                        className="button secondary mr-3"
                        onClick={() => this.editTrigger(false)}
                      >
                        Cancel
                      </button>
                      <button
                        className="button accent"
                        onClick={() => this.saveTriggerData()}
                      >
                        Save
                      </button>
                    </div>
                  ) : (
                    <button
                      className="button secondary"
                      onClick={() => {
                        this.editTrigger(true);
                        if (!this.props.isAnyTriggerEditing) {
                          this.getEdittedTriggerData(this.props.trigger);
                        }
                      }}
                      disabled={this.props.isAnyTriggerEditing && !this.state.isEdit}
                    >
                      Edit Trigger
                    </button>
                  )}
                </div>
                {!state.isEdit &&
                  props.trigger.filterOptions ?
                  (
                    <div>
                      <QueryBuilder disabled fields={fields} query={this.state.filterOptions} onQueryChange={q => this.setQuery(q)} />
                      <div className="pt15 time_on_page">
                        <div id="w50" className="d-flex">
                          <label className="field_label mr-4 mb-0">Time On Page In Seconds</label>
                          <input
                            required
                            type="number"
                            value={this.state.dynamicData.timeOnPage}
                            //value="305-000-0000"
                            onChange={(event) =>
                              this.setDynamicData("timeOnPage", event.target.value)
                            }
                            disabled={!state.isEdit}
                          />
                        </div>
                      </div>
                      <div className="pt15">
                        <label
                          id="destination-multi-label"
                          className="field_label"
                        >
                          Destination
                        </label>
                        <div className="select_multi">
                          <Select
                            labelId="destination-multi-label"
                            id="destination-multi"
                            multiple
                            value={state.selectedDestinations || []}
                            onChange={this.handleChangeDestination}
                            // renderValue={(selected) => (selected as string[]).join(', ')}
                            renderValue={(selected) =>
                              Array.from((selected) as any)
                                .map((item: any) => item.name)
                                .join(", ")
                            }
                            variant="outlined"
                            disabled={!state.isEdit}
                            name="destination-multi"
                          >
                            <MenuItem
                              value="NEW"
                            // classes={{ root: classes.checked }}
      
                            >
                              <AddIcon
                                fontSize="small"
                                style={{
                                  marginRight: "1rem",
                                  marginLeft: "0.5rem",
                                }}
                              />
                              Add New
                            </MenuItem>
                            {state.destinations.map((option) => (
                              <MenuItem key={option.id} value={option}>
                                <Checkbox
                                  // classes={{
                                  //   checked: classes.checked,
                                  //   colorSecondary: classes.colorSecondary,
                                  // }}
      
                                  checked={containsObject(
                                    option,
                                    state.selectedDestinations
                                  )}
                                />
                                <ListItemText primary={option.name} />
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </div>
                  ) :
                  (
                    <div id="test">
                      <QueryBuilderDnD dnd={{ ...ReactDnD, ...ReactDndHtml5Backend }}>
                        <QueryBuilder fields={fields} query={this.state.filterOptions} onQueryChange={q => this.setQuery(q)} />
                      </QueryBuilderDnD>
                      <div className="pt15">
                        <div id="w33" className="d-flex">
                          <label className="field_label mr-4 mb-0">Time On Page</label>
                          <input
                            required
                            type="number"
                            value={this.state.dynamicData.timeOnPage}
                            //value="305-000-0000"
                            onChange={(event) =>
                              this.setDynamicData("timeOnPage", event.target.value)
                            }
                            disabled={!state.isEdit}
                          />
                        </div>
                      </div>
                      <div className="pt15">
                        <label
                          id="destination-multi-label"
                          className="field_label"
                        >
                          Destination
                        </label>
                        <div className="select_multi">
                          <Select
                            labelId="destination-multi-label"
                            id="destination-multi"
                            multiple
                            value={state.selectedDestinations || []}
                            onChange={this.handleChangeDestination}
                            // renderValue={(selected) => (selected as string[]).join(', ')}
                            renderValue={(selected) =>
                              Array.from((selected) as any)
                                .map((item: any) => item.name)
                                .join(", ")
                            }
                            variant="outlined"
                            disabled={!state.isEdit}
                            name="destination-multi"
                          >
                            <MenuItem
                              value="NEW"
                              // classes={{ root: classes.checked }}
                              onClick={(e) => { this.props.emptyDestination() }}
                            >
                              <AddIcon
                                fontSize="small"
                                style={{
                                  marginRight: "1rem",
                                  marginLeft: "0.5rem",
                                }}
                              />
                              Add New
                            </MenuItem>
                            {state.destinations.map((option) => (
                              <MenuItem key={option.id} value={option}>
                                <Checkbox
                                  // classes={{
                                  //   checked: classes.checked,
                                  //   colorSecondary: classes.colorSecondary,
                                  // }}
      
                                  checked={containsObject(
                                    option,
                                    state.selectedDestinations
                                  )}
                                />
                                <ListItemText primary={option.name} />
                                <ListItemIcon>
                                  <EditIcon onClick={(e) => { 
                                    e.stopPropagation();
                                    this.editDestination(option.id, option);
                                  }} />
                                </ListItemIcon>
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </div>
                  )
                }
              </div>
            </>
          );
        }
      }
export default styled(TriggerCard)(({ theme }) => styles(theme));
